import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$provide',
  function (runtimeConstant, $provide) {
    function run() {
      try {
        $provide.decorator('multiSelectTreeDirective', [
          '$delegate',
          function ($delegate) {
            var directive = $delegate[0];

            directive.templateUrl =
              'views/directives/multi-select-tree.tpl.html';
            angular.extend(directive.scope, { enabled: '=' });

            return $delegate;
          },
        ]);

        $provide.decorator('treeItemDirective', [
          '$delegate',
          function ($delegate) {
            var directive = $delegate[0];

            directive.templateUrl = 'views/directives/tree-item.tpl.html';

            return $delegate;
          },
        ]);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
